'use client';

import { FormInput } from '@/components/form/FormInput';
import { useFieldContext } from '@/lib/form/contexts';

interface TextFieldProps {
  label: string;
  type?: string;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
}

export const TextField = ({
  label,
  type,
  autoComplete,
  required,
  placeholder,
}: TextFieldProps) => {
  const field = useFieldContext<string>();
  return (
    <FormInput
      label={label}
      type={type}
      name={field.name}
      autoComplete={autoComplete}
      required={required}
      placeholder={placeholder}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={field.state.meta.errors[0]?.message}
    />
  );
};
